<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button>Edit</form-edit-button>
      <app-form-delete-button [Parent]="this" [Model]="Model" DeleteUrl="valet/stations/" Api="valet" TypeName="ValetStation"
      DeleteNavLink="/valet/stations"></app-form-delete-button>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Valet Station Details
          </p>
          <div class="panel-block">
            <span class="label">Id:</span>
            <span class="value">{{Model.Id}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Name:</span>
            <span class="value">{{Model.Name}}</span>
          </div>
          <div class="panel-block">
            <span class="label">High Volume Mode:</span>
            <span class="value">{{Model.HighVolumeModeEnabled ? 'Enabled' : 'Disabled'}}</span>
          </div>
          <div class="panel-block">
            <span class="label">Send SMS Survey:</span>
            <span class="value">{{Model.SendSmsSurvey ? 'Enabled' : 'Disabled'}}</span>
          </div>
          @if (Model.SendSmsSurvey) {
            <div class="panel-block">
              <span class="label">Survey Delay:</span>
              <span class="value">{{Model.SurveyDelay}} minutes</span>
            </div>
          }
          <div class="panel-block">
            <span class="label">Expected Wait Time:</span>
            <span class="value">{{Model.ExpectedWaitTime != null ? Model.ExpectedWaitTime + ' minutes' : 'Not set'}}</span>
          </div>
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Session Summary
          </p>
          <div class="panel-block">
            <span class="label">Today's Sessions:</span>
            <span class="value">{{Model.TodaySessionCount}}</span>
          </div>
          @if (Model.SessionCountsByState?.length > 0) {
            <p class="panel-heading is-size-7">
              Sessions by State
            </p>
          }
          @for (state of Model.SessionCountsByState; track state) {
            <div class="panel-block">
              <span class="label">{{state.StateName}}:</span>
              <span class="value">{{state.Count}}</span>
            </div>
          }
        </article>
      </div>
    </div>
    @if (Model.ParkingLots && Model.ParkingLots.length > 0) {
      <div class="columns">
        <div class="column is-6">
          <article class="panel">
            <p class="panel-heading">
              Parking Lots
            </p>
            @for (lot of Model.ParkingLots; track lot) {
              <div class="panel-block">
                <span class="value">{{lot.ParkingLotName || lot.ParkingLotId}}</span>
              </div>
            }
          </article>
        </div>
      </div>
    }
    @if (Model.PaymentTerminals && Model.PaymentTerminals.length > 0) {
      <div class="columns">
        <div class="column is-12">
          <article class="panel">
            <p class="panel-heading">
              Payment Terminals
            </p>
            <div class="panel-block" style="display: block;">
              <table class="table is-striped is-bordered is-fullwidth">
                <thead>
                  <tr>
                    <th style="width: 1%; white-space: nowrap;">Type</th>
                    <th>Serial Number</th>
                    <th>Device Id</th>
                    <th>POS Name</th>
                  </tr>
                </thead>
                <tbody>
                  @for (terminal of Model.PaymentTerminals; track terminal) {
                    <tr>
                      <td style="width: 1%; white-space: nowrap;">{{TerminalTypeName(terminal.TerminalType)}}</td>
                      <td>{{terminal.SerialNumber}}</td>
                      <td>{{terminal.DeviceId}}</td>
                      <td>{{terminal.PosName}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </article>
        </div>
      </div>
    }
  </div>
}
